export default {
  // 设置待处理的任务
  SET_PENDING_TASK(state, { task, action }) {
    state.pendingTask = task;
    state.pendingAction = action;
  },

  // 清除待处理的任务
  CLEAR_PENDING_TASK(state) {
    state.pendingTask = null;
    state.pendingAction = null;
  },

  // 设置特定工具的历史记录
  SET_HISTORY_CACHE(state, { toolName, tasks }) {
    state.historyCache = {
      ...state.historyCache,
      [toolName]: tasks,
    };
  },

  // 清除特定工具的历史记录缓存
  CLEAR_HISTORY_CACHE(state, toolName) {
    if (toolName) {
      const { [toolName]: _, ...rest } = state.historyCache;
      state.historyCache = rest;
    } else {
      // 清除所有缓存
      state.historyCache = {};
    }
  },
};
